//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    components: {},
    data () {
      return {}
    },
    created () {
    },
    methods: {
      click (type) {
        this.$router.replace({name: 'reportMain', path: '/reportMain', query: { type }})
      }
    }
  }



// WEBPACK FOOTER //
// ./src/views/vioReport/ReportType.vue